import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import {
  CuiCodeSnippet,
  CuiDescriptionLayout,
  CuiInteractiveExample,
  CuiPage,
  CuiSectionLayout,
  CuiPageTitle,
  CuiRhythm,
  CuiTextBlock,
} from '../../components';

import { CuiRedirectCallout } from '../../components';
// import { NewsletterSignUpForm } from '../newsletterSignUpForm';
// import { BuyCallToAction } from '../buyCallToAction';

export const DemoPage = ({ title, html, css, js, children }) => (
  <CuiPage>
    <CuiPageTitle>{title}</CuiPageTitle>

    <CuiSectionLayout>
      <CuiInteractiveExample html={html} js={js} />

      <CuiRhythm size="xxl">
        <CuiDescriptionLayout>
          <CuiTextBlock>{children}</CuiTextBlock>
        </CuiDescriptionLayout>
      </CuiRhythm>

      {/* <CuiRhythm size="xxl">
        <BuyCallToAction />
      </CuiRhythm> */}

      <CuiCodeSnippet type="css" code={css} />
      <CuiCodeSnippet type="html" code={html} />
      {js && <CuiCodeSnippet type="javascript" code={js} />}

      <CuiRhythm size="xxl">
        <CuiRedirectCallout
          title="More stuff"
          subTitle={<Fragment>
            If you like my writing you can find more at my blog, <a href="https://www.cenizal.com">cenizal.com</a>. Right now I'm mostly writing about people management, software engineering, and interaction design.
          </Fragment>}
        />
      </CuiRhythm>
    </CuiSectionLayout>
  </CuiPage>
);

DemoPage.propTypes = {
  title: PropTypes.string.isRequired,
  html: PropTypes.string.isRequired,
  css: PropTypes.string.isRequired,
  js: PropTypes.string,
  children: PropTypes.node.isRequired,
};

DemoPage.defaultProps = {
  js: '',
};



// WEBPACK FOOTER //
// ./ui/partials/demoPage/DemoPage.js